/* tslint:disable */
import $ from "jquery";
import { App } from "./Main";

let historyNA: any = null;

// Function to trigger reply from React component
export function triggerReply(messageId: string, authorName: string) {
    const messageWrapper = $(`.message-wrapper[data-id='${messageId}']`);
    if (messageWrapper.length === 0) {
        console.warn("Message wrapper not found for reply");
        return;
    }

    const $roomElement = messageWrapper.closest(".room");
    const quoteTextId = messageId;
    const quoteAuthor = authorName;
    let messageDiv = messageWrapper.find(".message").clone();
    messageDiv.find(".quote,.message-author,.reply,.read-by,.message-reactions-container").remove();
    messageDiv = messageDiv
        .removeClass("message")
        .css({ display: "flex" })
        .prepend(`<b>${quoteAuthor}</b>`);
    messageDiv.find(">span").addClass("quoted");

    $roomElement
        .find(".typing-and-input")
        .removeClass("in-edit-mode")
        .find(".edit-preview #reply-preview")
        .remove();

    const previewArea = $(
        `<div id="reply-preview" data-id="${quoteTextId}">` +
            '<div class="reply-preview-area">' +
            '<div class="edit-preview-title">Reply to</div>' +
            '<div class="edit-preview-message"></div>' +
            "</div>" +
            '<div title="Cancel reply" class="reply-preview-close">' +
            '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
            '<g stroke="#687480" stroke-width="2"><path d="M0,8 L16,8"></path><path d="M8,0 L8,16"></path></g>' +
            "</svg>" +
            "</div>" +
            "</div>"
    );

    $roomElement
        .find(".typing-and-input")
        .addClass("in-edit-mode")
        .find(".edit-preview")
        .append(previewArea);
    previewArea
        .find(".reply-preview-close")
        .on("click", () => resetReplyElements($roomElement, true));
    previewArea.find(".edit-preview-message").prepend(messageDiv);
}

$(() => {
    historyNA = $(
        '<div style="position: absolute; left: 50%;">' +
            '<div style="position: relative; left: -50%; color: #ff0000;">' +
            "Quoted message not loaded!" +
            "</div></div>"
    );

    setTimeout(() => {
        let node = $(".rooms-container").get(1);
        if (node) {
            // observe for existing rooms
            $(node)
                .find(".room")
                .each((index, roomNode) =>
                    new MutationObserver(event => handleEditEvent($(roomNode), event)).observe(
                        $(roomNode)
                            .find(".typing-and-input .edit-preview")
                            .get(0),
                        { childList: true }
                    )
                );

            // Observe for future rooms
            new MutationObserver(mutations => {
                mutations.forEach(record => {
                    record.addedNodes.forEach(node => {
                        const roomNode = $(node).find(".room");
                        new MutationObserver(event => handleEditEvent(roomNode, event)).observe(
                            $(node)
                                .find(".typing-and-input .edit-preview")
                                .get(0),
                            { childList: true }
                        );
                    });
                });
            }).observe(node, { childList: true });
        } else {
            console.error("Can't observe rooms container!");
        }
    }, 100);

    setTimeout(
        () =>
            $(".rooms-container").on("click", ".quote", e => {
                const textId = $(e.currentTarget).data("id");
                const quotedMessage = $(`.message-wrapper[data-id='${textId}']`).get(0);
                if (quotedMessage) {
                    quotedMessage.scrollIntoView({ behavior: "smooth" });
                } else {
                    showNoHistoryError(e.currentTarget);
                }
            }),
        100
    );

    setTimeout(
        () =>
            $(".rooms-container").on("keyup", ".DraftEditor-root", e => {
                if (e.which === 27) {
                    // Escape key
                    const $roomElement = $(e.currentTarget).closest(".room");
                    resetReplyElements($roomElement, true);
                }
            }),
        100
    );

    const originalSendRoomText = App.proto.sendRoomText;
    const hijackedSendRoomText = (...args: any[]) => {
        const data = args[0];
        const roomId = data.room_id;
        const quoteTextId = $(`.room[data-roomid="${roomId}"]`)
            .find(".edit-preview #reply-preview")
            .data("id");
        if (quoteTextId) {
            data.quote = { text_id: quoteTextId };
        }
        const $roomElement = $(`.room[data-roomid="${roomId}"]`);
        setTimeout(() => resetReplyElements($roomElement, true), 0);
        // @ts-ignore
        return originalSendRoomText.apply(App.proto, args);
    };
    App.proto.sendRoomText = hijackedSendRoomText;

    const originalUpdateRoomText = App.proto.updateRoomText;
    const hijackedUpdateRoomText = (...args: any[]) => {
        const data = args[0];
        const roomId = data.room_id;
        const quoteTextId = $(`.room[data-roomid="${roomId}"]`)
            .find(".edit-preview #reply-preview")
            .data("id");
        if (quoteTextId && data.id !== quoteTextId) {
            data.quote = { text_id: quoteTextId };
        }
        const $roomElement = $(`.room[data-roomid="${roomId}"]`);
        setTimeout(() => resetReplyElements($roomElement, true), 0);
        // @ts-ignore
        return originalUpdateRoomText.apply(App.proto, args);
    };
    App.proto.updateRoomText = hijackedUpdateRoomText;
});

function showNoHistoryError(target: any) {
    $(target)
        .closest(".room")
        .find(".room-header")
        .append(historyNA);
    setTimeout(() => historyNA.detach(), 2000);
}

function resetReplyElements($roomElement: any, resetEdit: boolean) {
    if ($roomElement) {
        $roomElement
            .find(".typing-and-input")
            .removeClass(resetEdit ? "in-edit-mode" : "")
            .find(".edit-preview #reply-preview")
            .remove();
    }
}

function showUpdateReplyPreview($quotedMessage: any) {
    const quoteTextId = $quotedMessage.data("id");
    $quotedMessage = $quotedMessage.clone().css({ display: "flex" });
    $quotedMessage.find(".timestamp").remove();

    const previewArea = $(
        `<div id="reply-preview" data-id="${quoteTextId}">` +
            '<div class="reply-preview-area">' +
            '<div class="edit-preview-title">Reply to</div>' +
            '<div class="edit-preview-message"></div>' +
            "</div>" +
            '<div title="Remove reply" class="reply-preview-close">' +
            '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
            '<g stroke="#687480" stroke-width="2"><path d="M0,8 L16,8"></path><path d="M8,0 L8,16"></path></g>' +
            "</svg>" +
            "</div>" +
            "</div>"
    );

    const $roomElement = $(`.quote[data-id='${quoteTextId}']`).closest(".room");
    $roomElement.find(".typing-and-input .edit-preview").append(previewArea);

    $roomElement.on("click", ".reply-preview-close", e => {
        e.stopPropagation();
        e.preventDefault();
        resetReplyElements($roomElement, false);
    });

    previewArea.find(".edit-preview-message").prepend($quotedMessage);
}

function handleEditEvent($roomNode: any, mutations: any) {
    mutations.forEach((record: any) => {
        if (record.addedNodes.length && $(record.addedNodes[0]).attr("id") !== "reply-preview") {
            const messageId = $(record.addedNodes[0]).data("id");
            const $quotedMessage = $roomNode.find(
                `.message-wrapper[data-id="${messageId}"] .quote`
            );
            if ($quotedMessage.length) {
                showUpdateReplyPreview($quotedMessage);
            }
        } else if (record.removedNodes.length) {
            const $roomElement = $(record.removedNodes[0]).closest(".room");
            resetReplyElements($roomElement, true);
        }
    });
}

export default {};
